export default __webpack_public_path__ + "static/media/icon-supervisor.2dd10a2d.svg";